import type { ReactNode } from "react";

interface SectionHeaderProps {
  title: ReactNode;
  hint?: ReactNode;
  actions?: ReactNode;
}

/** Sub-section header used to group content within a page. */
export function SectionHeader({ title, hint, actions }: SectionHeaderProps) {
  return (
    <div className="section-header">
      <div className="cluster" style={{ gap: "var(--space-2)" }}>
        <span className="section-header__title">{title}</span>
        {hint && <span className="section-header__hint">{hint}</span>}
      </div>
      {actions && <div className="card-actions">{actions}</div>}
    </div>
  );
}
